/**
 * Style Genome — public facade.
 *
 * The single import point for the design-language registry: the genomes, their
 * accessors, the validator, and the vocabulary/schema. Every genome is
 * validated at load so a malformed entry fails fast in development rather than
 * reaching the Thinking Engine.
 *
 * The Thinking Engine consumes genomes; the compiler and editor never do.
 */

import { GENOMES } from './genomes';
import { validateGenome } from './validateGenome';

// Fail fast: the whole registry must satisfy the frozen genome contract.
GENOMES.forEach((genome) => {
  const { valid, errors } = validateGenome(genome);
  if (!valid) {
    throw new Error(`Invalid Style Genome "${genome && genome.id}": ${errors.join('; ')}`);
  }
});

const byId = new Map(GENOMES.map((g) => [g.id, g]));

/** All genomes. */
export const listGenomes = () => GENOMES.map(({ id, name, family }) => ({ id, name, family }));

/** Look up a genome by id (returns the frozen genome, or null). */
export const getGenome = (id) => byId.get(id) || null;

export { GENOMES };
export { validateGenome } from './validateGenome';
export { GENOME_SCHEMA_ID, GENOME_VERSION, GENOME_FIELDS, EXPANSION_FIELDS, IDENTITY_FIELDS } from './genomeSchema';
export * as vocabulary from './vocabulary';
